import React from "react";
import PageHeader from "../components/PageHeader";
import Investors from "../components/Investors";
import useSEO from "../lib/seo";

export default function InvestorsPage() {
  useSEO({
    title: "Investors & Developers | Build in Jamaica with Confidence · LNZ",
    description:
      "Your on-the-ground partner in Jamaica & the Caribbean. LNZ provides regulatory navigation, end-to-end execution and local expertise for international investors, diaspora clients and commercial developers.",
    path: "/investors",
    keywords:
      "invest in Jamaica, Jamaica real estate developer, diaspora construction, commercial developer Caribbean, NEPA approval Jamaica, regulatory guidance, build in Jamaica",
  });
  return (
    <div data-testid="investors-page">
      <PageHeader
        overline="INVESTORS & DEVELOPERS"
        title="Your on-the-ground partner in "
        accent="Jamaica & the Caribbean."
        description="From feasibility and land acquisition through to commissioning, LNZ delivers the local expertise, regulatory navigation and execution discipline international investors and developers require."
      />
      <Investors />
    </div>
  );
}
